import React from "react";
import { type LucideIcon } from "lucide-react";

interface CapabilityCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  tag: string;
}

const CapabilityCard: React.FC<CapabilityCardProps> = ({
  icon: Icon,
  title,
  description,
  tag,
}) => (
  <div className="flex h-full flex-row items-start gap-4 rounded-2xl bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl dark:bg-slate-800">
    <div className="grid h-11 w-11 flex-shrink-0 place-items-center rounded-xl bg-cream-dark text-primary dark:bg-primary/15 dark:text-primary-light">
      <Icon className="h-5 w-5" />
    </div>
    <div className="flex min-w-0 flex-1 flex-col gap-2">
      <h3 className="text-base font-bold leading-tight tracking-tight text-gray-900 dark:text-white">
        {title}
      </h3>
      <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
        {description}
      </p>
      <div className="mt-1.5 self-start rounded-full bg-cream-dark px-3.5 py-1.5 text-sm font-bold text-primary dark:bg-primary/15 dark:text-primary-light">
        {tag}
      </div>
    </div>
  </div>
);

export default CapabilityCard;
